import React, { useState } from 'react'
import { format } from 'date-fns'

const TaskDueDate = ({ taskId, dueDate, onUpdateTaskDate }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [dateInput, setDateInput] = useState(dueDate ? dueDate.split('T')[0] : '')

  const handleDateChange = e => {
    setDateInput(e.target.value)
  }

  const handleSaveDate = () => {
    if (dateInput) {
      const newDate = new Date(dateInput)
      onUpdateTaskDate(taskId, newDate)
    } else {
      onUpdateTaskDate(taskId, null)
    }
    setIsEditing(false)
  }

  const handleCancel = () => {
    setDateInput(dueDate ? dueDate.split('T')[0] : '')
    setIsEditing(false)
  }

  const formatDisplayDate = dateString => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return format(date, 'dd/MM/yyyy')
  }

  return (
    <div className='task-due-date'>
      {isEditing ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <input
            type='date'
            value={dateInput}
            onChange={handleDateChange}
            style={{
              padding: '4px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '12px',
            }}
          />
          <button
            onClick={handleSaveDate}
            style={{
              padding: '4px 8px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
            }}
          >
            ✓
          </button>
          <button
            onClick={handleCancel}
            style={{
              padding: '4px 8px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
            }}
          >
            ✗
          </button>
        </div>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          {dueDate && <span className='due-date-text'>Límit: {formatDisplayDate(dueDate)}</span>}
          <button
            onClick={() => setIsEditing(true)}
            style={{
              padding: '4px 8px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
              marginLeft: '5px',
            }}
          >
            {dueDate ? 'Canviar data' : 'Afegir data'}
          </button>
        </div>
      )}
    </div>
  )
}

export default TaskDueDate
